import { NgModule } from '@angular/core';
import { ZonedAsyncPipe } from './zoned-async.pipe';

@NgModule({
  declarations: [
    ZonedAsyncPipe
  ],
  exports: [
    ZonedAsyncPipe
  ]
})
export class ZonedAsyncModule { }
